import { render, staticRenderFns } from "./AmbassadorRecommends.vue?vue&type=template&id=3eb5e5c6&lang=pug"
import script from "./AmbassadorRecommends.vue?vue&type=script&lang=js"
export * from "./AmbassadorRecommends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports